import { useNavigate } from 'react-router-dom';
import { useDatasourceId } from '@/hooks';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectInitialPathname, selectPenultimateUndoId, undo } from '../slice';

export const useUndo = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();
  const nextQueryId = useAppSelector(selectPenultimateUndoId);
  const initialPathname = useAppSelector(selectInitialPathname);

  const nextUrl = nextQueryId
    ? `/datasources/${datasourceId}/queries/${nextQueryId}`
    : initialPathname!;

  return () => {
    dispatch(undo());
    navigate(nextUrl);
  };
};
